export const shouldMuteMedia = (
  enabled: boolean,
  shouldMute?: boolean
): boolean => {
  return enabled && (shouldMute || false);
};
